import React, { useEffect, useRef, type ReactNode } from 'react';

import { useFocusedField } from '../../../../contexts/focused-field-provider';
import { useScroll } from '../../../../contexts/scroll-provider';

type FocusableProps = {
  children: ReactNode;
  fieldId: string;
};

export const Focusable = ({ children, fieldId }: FocusableProps) => {
  const viewRef = useRef<HTMLDivElement>(null);
  const { scrollTo } = useScroll();
  const { focusedFieldId } = useFocusedField();

  useEffect(() => {
    if (viewRef.current && fieldId === focusedFieldId) {
      scrollTo(viewRef.current);
    }
  }, [scrollTo, fieldId, focusedFieldId]);

  return <div ref={viewRef}>{children}</div>;
};
